import thunk from 'redux-thunk'
import Axios from 'axios'
import keys from '../../../keys'
import { loginRequest, loginSuccess, loginFailed } from "./actions"



export const login = (credentials , successCallback , errorCallback) => {
    console.log("login called")
    return dispatch => {
        dispatch(loginRequest())
        Axios.post(`${keys.server}/user/get-auth-token/`,credentials)
        .then(
            result => {
                console.log(result)
                if(result.data.success){
                    dispatch(loginSuccess(result.data,credentials.remember))
                    successCallback(result.data.message)

                }else{
                    throw Error(result.data.message)
                }
               
            }
        )
        .catch(err=>{
            console.error("Error")
            if (err.response.status===401){
                errorCallback("Username or password is incorrect")
            }else{
                errorCallback("Oops! Something went wrong, please contact support!")
            }       
            dispatch(loginFailed(err))
        })
    }
}

